<div class="topHead">

    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">

<div class="adminTabWrap">
    <!-- <div class="numberOfUsers" *ngIf="totalUserDetail">
        <ul>
            <li>
                <div class="showUsers">
                    <h3>{{totalUserDetail?.total_user}} total Users</h3>
                </div>
            </li>
            <li>
                <div class="showUsers green">
                    <b><i></i>{{totalUserDetail?.total_active}}</b>
                    <span>Active Users</span>
                </div>
            </li>
            <li>
                <div class="showUsers bluecolor">
                    <b><i></i>{{totalUserDetail?.total_deactive}}</b>
                    <span>Deactive Users</span>
                </div>
            </li>
        </ul>
    </div> -->
<div class="pageTitleBox">
    <h2>User Management</h2>
    <div class="filterWrap">
        <div class="searchWrap">
            <input type="text" placeholder="Search Users" #searchUser />
            <!-- <input type="text" placeholder="Search Users"  (keyup)="getUser(event: $event)"  /> -->
        </div>
        <div class="col-12 col-md-4">
            <div class="filterSelect">
                <span>Filter by Organisation:</span>
                <div class="selectCustom w-auto">
                    <select (change)="selectChangeHandler($event)">
                        <option value='0'>All</option>
                        <option *ngFor="let organisation of organisationData" [value]="organisation.organisation_id">{{organisation.org_name}}</option>
                    </select>

                </div>
            </div>
        </div>
        <a href="javascript:void(0);" [routerLink]="['/user_create']" class="btn btn-primary btn-sm" >+ Create New user</a>
    </div>
</div>

    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onSelectChange($event)">
        <mat-tab label="Active">
            <div class="tableWrap">

                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th>Email ID</th>
                            <th>Phone Number</th>
                            <th>Organisation</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                    <!--class="selectTr"-->
                        <tr  *ngFor="let values of userDataList; let i = index" >
                            <td>{{i+1}}</td>
                            <td>
                                <div class="userTdWrap">
                                   <a class="btn-link"> <span>{{values.first_name}} {{values.last_name}}</span></a>
                                    <b>Created on {{values.modified_dttm}}</b>
                                </div>
                            </td>
                            <td>
                                {{values.email}}
                            </td>
                            <td>{{values.phone}}</td>
                            <td>{{values.organisation_name}}</td>
                            <td>
                                <ul class="userActionBtn">
                                    <li>
                                        <b class="notYet" *ngIf="values.req_status==1">
                                            <img src="assets/images/admin/frameNot.png">
                                        </b>
                                    </li>
                                    <li><a href="javascript:void(0);"  class="btn-link" [routerLink]="['/view_courses']" [queryParams]="{user_id:values.user_id}">VIEW COURSES</a></li>
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/assign_courses']" [queryParams]="{user_id:values.user_id}">ASSIGN COURSES</a></li>
                                    <li><a href="javascript:void(0);" class="btn-link" [routerLink]="['/user_edit']" [queryParams]="{id:values.user_id,type:'edit'}" >EDIT</a></li>
                                    <!-- <li><a href="javascript:void(0);" class="btn-link" >EDIT</a></li> -->
                                    <li><a href="javascript:void(0);" class="btn-link second-link" (click)="open(deactivate,values.user_id,'Active')">DEACTIVATE</a></li>
                                    <li><a href="javascript:void(0);" class="btn-link second-link" (click)="open(delete,values.user_id,'Active')">DELETE</a></li>

                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>

                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Deactivated" >
            <div class="tableWrap">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                            <th>Email ID</th>
                            <th>Phone Number</th>
                            <th>Organisation</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- class="selectTr" -->
                        <tr  *ngFor="let values of userDataList; let i = index">
                            <td>
                                <div class="userTdWrap">
                                   <a class="btn-link"> <span>{{values.first_name}} {{values.last_name}}</span></a>
                                    <b>Created on {{values.modified_dttm}}</b>
                                </div>
                            </td>
                            <td>
                                {{values.email}}
                            </td>
                            <td>{{values.phone}}</td>
                            <td>{{values.organisation_name}}</td>
                            <td>
                                <ul class="userActionBtn">
                                    <li class="w-auto"><a href="javascript:void(0);"  class="btn-link" [routerLink]="['/view_courses']" [queryParams]="{user_id:values.user_id}">VIEW COURSES</a></li>
                                    <li class="w-auto"><a href="javascript:void(0);" class="btn-link-green" (click)="open(active,values.user_id,'Deactivated')">ACTIVATE</a></li>
                                    <li class="w-auto"><a href="javascript:void(0);" class="btn-link second-link" (click)="open(delete,values.user_id,'Deactivated')">DELETE</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="selectTr" style="background-color: white;" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
      </mat-tab-group>
    </div>
</div>
<ngx-spinner><p style="color: white" > Loading... </p></ngx-spinner>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate user</h6>
                <p class="size18">Are you sure you want to deactivate this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                    <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsDeActiveVal(user_id,0)">Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete user</h6>
                <p class="size18">Are you sure you want to delete this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="deleteUser(user_id)">Yes,
                    Delete</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #active let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate user</h6>
                <p class="size18">Are you sure you want to activate this user?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="changeIsActiveVal(user_id,1)">Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>


